import React from 'react'
import PropTypes from 'prop-types'

export const ReactElement = (props, propName, componentName) => {
  const prop = props[propName]
  if (!prop) {
    return
  }
  if (!React.isValidElement(prop)) {
    return new Error(
      `Invalid prop \`${propName}\` of type \`${typeof prop}\` supplied to \`${componentName}\`, expected \`React Element\`.`
    )
  }
}

ReactElement.isRequired = (props, propName, componentName) => {
  const prop = props[propName]
  if (!prop) {
    return new Error(
      `The prop \`${propName}\` is marked as required in \`${componentName}\`, but its value is \`${prop}\`.`
    )
  }

  return ReactElement(props, propName, componentName)
}

export const RefType = PropTypes.oneOfType([
  PropTypes.func,
  PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
])



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/libs/custom-prop-types.js